import Icon from '@ant-design/icons/lib/components/Icon';
import React from 'react';
import GuuruSvg from './GuuruOutlined.svg';

const GuuruOutlined = function ({
  ref,
  ...props
}: React.ComponentProps<typeof Icon> & {
  ref?: React.Ref<HTMLSpanElement>;
}) {
  return <Icon aria-label="guuru" component={GuuruSvg} ref={ref} {...props} />;
};

export default GuuruOutlined;
